import _Slider from "hzero-ui/lib/slider";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createGlobalStyle } from "styled-components";
import React, { useCallback, useEffect, useRef, useState, forwardRef, useImperativeHandle, useContext } from "react";
import ThemeContext from "@hzero-front-ui/core/lib/utils/ThemeContext";
import "./css";
function resolveTip(themeContext) {
  return !themeContext.originTheme || !themeContext.originTheme.slider || !themeContext.originTheme.slider.showTip ? null : function (t) {
    return t;
  };
}
var SliderGlobalStyle = createGlobalStyle([".slider-handle-underlay{display:none;}"]);
export default forwardRef(function (props, ref) {
  var sliderRef = useRef(null);
  var theme = useContext(ThemeContext) || {};
  useImperativeHandle(ref, function () {
    return sliderRef;
  });
  var showTip = resolveTip(theme);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    div = _useState2[0],
    setDiv = _useState2[1];
  var handleChange = useCallback(function (v) {
    if (props.onChange) {
      props.onChange(v);
    }
    div.textContent = v;
  }, [div.textContent, props]);
  useEffect(function () {
    if (typeof document !== "undefined") {
      var _div = document.createElement("div");
      _div.className = "slider-handle-underlay";
      setDiv(_div);
      var slider = sliderRef.current.rcSlider.sliderRef;
      var handle = slider.getElementsByClassName("ant-slider-handle")[0];
      handle.append(_div);
    }
  }, []);
  useEffect(function () {
    div.textContent = props.value || props.defaultValue || 0;
  }, [div, props.defaultValue, props.value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SliderGlobalStyle, null), /*#__PURE__*/React.createElement(_Slider, Object.assign({
    ref: sliderRef
  }, props, {
    onChange: handleChange,
    tipFormatter: showTip
  })));
});